import { render } from "./Login.vue?vue&type=template&id=4eedd6ac"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
script.render = render

export default script